var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoUnpaidInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.241 14.1667H26.7507C24.8571 14.1667 23.3335 15.7017 23.3335 17.5953V125.738C23.3335 127.632 24.8685 129.167 26.7621 129.167H40.7383C42.6318 129.167 44.1668 130.702 44.1668 132.595V141.988C44.1668 143.882 45.7019 145.417 47.5954 145.417H110.646C111.566 145.417 112.447 145.048 113.091 144.392L135.683 121.417C136.313 120.776 136.667 119.913 136.667 119.013V39.2619C136.667 37.3684 135.132 35.8334 133.238 35.8334H125.095C123.202 35.8334 121.667 34.2983 121.667 32.4048V17.5953C121.667 15.7017 120.134 14.1667 118.241 14.1667Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0688 125.116H48.5088",
    stroke: "#F4F6F6",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0688 18.2673V125.115",
    stroke: "#F4F6F6",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.453 18.2673H27.0688",
    stroke: "#F4F6F6",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.451 39.5633V18.2673",
    stroke: "#F4F6F6",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4888 39.5961V39.5641V141.724",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.921 39.5945H48.4888",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4888 141.723H110.489C119.257 132.955 124.185 128.043 132.921 119.307V39.5945",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4888 141.723H110.489C119.257 132.955 124.185 128.043 132.921 119.307V39.5945",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.489 141.723V119.227H132.921",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.693 58.9079H61.7251",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.693 80.0737H61.7251",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6851 101.227H61.7251",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6851 122.412H61.7251",
    stroke: "#1D4650",
    strokeOpacity: 0.85,
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUnpaidInvoices);
export default __webpack_public_path__ + "static/media/no-unpaid-invoices.9e0d2388613808c11ab0020e5bbe34a0.svg";
export { ForwardRef as ReactComponent };